import { render, staticRenderFns } from "./SectionMessage.vue?vue&type=template&id=3b254077&scoped=true"
import script from "./SectionMessage.vue?vue&type=script&lang=js"
export * from "./SectionMessage.vue?vue&type=script&lang=js"
import style0 from "./SectionMessage.vue?vue&type=style&index=0&id=3b254077&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b254077",
  null
  
)

export default component.exports